import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FilterLineForInListFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartInListFilterRenderer = ({
  filter
}) => {
  // If there is metadata on the IN_LIST filter, it will be represented differently in the UI
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: filter.metadata ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: `flow-doctor-lib.filters.inList.labels.${filter.metadata.inListType}`
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.inList.labels.default"
    }),
    filterLine: /*#__PURE__*/_jsx(FilterLineForInListFilter, {
      filter: filter
    })
  });
};
export default WalmartInListFilterRenderer;